module.exports = __webpack_public_path__ + "media/200_HC_2023_Introduction.d5ee9a43.mp4";